<template>
  <div class="modal_action card">

    <div class="header">
      <span class="block"> {{ label }} </span>
    </div>

    <div
      v-if="data"
      class="params"
    >
      <div
        v-for="(param, param_key) in data"
        :key="param_key"
        class="param"
      >
        <fg-input
          :type="selected_type(param.type)"
          v-model="param.value"
          :range="false"
          :label="param_key"
          :disabled="param_key === 'ts_end'"
        />
      </div>

    </div>

    <div style="text-align: center;">
      <span class="block"> {{ translate('ask_action') }} </span>
    </div>

    <div class="text-center">
      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="updateSimcard"
      >
        {{ translate('yes') }}
      </button>

      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('no') }}
      </button>
    </div>
  </div>

</template>
<script>

export default {
  name: 'ModalAction',
  props: ['hidden_data', 'label'],

  data () {
    return {
      data: {}
    }
  },
  created(){
    let new_date = Math.round(new Date().getTime() / 1000)

    for (let index in this.hidden_data) {
      if (typeof(this.hidden_data[index]) == 'object') {
        this.data[index] = this.hidden_data[index]
      }
      if (index === 'ts_end') {
        this.data[index].value = '' + new_date
      }
    }
  },
  methods: {
    clear_all(){
      if (this.data) {
        for (let key in this.data) {
          this.data[key].value = ''
        }
      }
    },
    selected_type(type){
      switch (type) {
        case "DatePicker":
          return "datepicker"
        case "input":
          return "text"
      }
    },
    cancel () {
      this.clear_all()
      this.$emit('close')
    },
    updateSimcard(){
      let new_data = {}
      for (let key in this.hidden_data) {
        if (typeof(this.hidden_data[key]) != 'object') {
          new_data[key] = this.hidden_data[key]
        }
      }

      for (let key in this.data) {
        new_data[key] = this.data[key].value
      }

      this.$emit('apply', new_data)
      this.clear_all()
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_action{
    padding: 10px;
    background-color: #FFFFFF;
    .header{
      text-align: center;
      padding: 0 10px 10px 10px;
      font-size: 16px;
      font-weight: bold;
    }
    .params{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      .param{
        min-width: 210px;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
        label{
          display: block;
        }
      }
    }
  }


</style>
